import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'amfe-flexible/index.js' // px转rem
import '@/utils/rem.js'
// 引入Vant UI组件的样式
import 'vant/lib/index.css'
import './core/index.js'

import 'leaflet/dist/leaflet.css'
// 引入Leaflet对象 挂载到Vue上，便于全局使用，也可以单独页面中单独引用
import * as L from 'leaflet' // leaflet
import map from './utils/map.js'
import config from './config'
import headerTop from './components/head/index'
import highcharts from 'highcharts'
import HighchartsVue from 'highcharts-vue'
import highcharts3d from 'highcharts/highcharts-3d'
import * as echarts from 'echarts' // echarts
import download from './utils/file-download'
import request from '@/utils/request'
import 'echarts-gl'
highcharts3d(highcharts)

Vue.component('headTop', headerTop)
Vue.prototype.$url = process.env.VUE_APP_BASE_URL // 获取当前请求路径,用于拼接图片,文件加载
Vue.prototype.$api = process.env.VUE_APP_BASE_URL + 'api/common/file/download?fileId=' // 获取当前请求路径,用于拼接图片,文件加载
Vue.prototype.$pdf = process.env.VUE_APP_APP_PDF_VIEWER // 获取pdf预览
Vue.prototype.$config = config // 配置
// 文件下载
Vue.prototype.$download = (id, options) => download(id, {
  request,
  downloadApi: config.file.download,
  ...options
})
Vue.use(HighchartsVue)
Vue.config.productionTip = false// echarts 3D
Vue.prototype.$echarts = echarts

Vue.L = Vue.prototype.$L = L
Vue.prototype.$map = map

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
